import router from './router'
import usePromotionStore from './store'
import PromotionMessages from './localization'

export default {
  router,
  usePromotionStore,
  localization: PromotionMessages,
}
